import { createContext } from 'react';

export type TPortalContextValue = {
  module?: Nullable<string>;
  companyId?: Nullable<string>;
  companyAddressId?: Nullable<string>;
  userid?: Nullable<string>;
};
export const PortalContext = createContext<TPortalContextValue>({
  module: '',
  companyId: null,
  companyAddressId: null,
  userid: null,
});
